import React from 'react';
import Close from 'mdi-react/CloseIcon';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { merge } from './helpers.js';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_BackDrop__DslUV{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.5);z-index:5004;display:flex;align-items:center;justify-content:center;transition:background-color .25s}.styles-module_ModalWrapper__2HHmh{color:var(--white);max-width:400px;width:100%;z-index:666;border-radius:10px;background-color:var(--graybackground);overflow:hidden;animation-duration:.25s;animation-fill-mode:both;transform-origin:center center;box-shadow:0 10px 20px 0 rgba(0,0,0,.19),0 6px 6px 0 rgba(0,0,0,.26)}.styles-module_EnlargeOut__2dM_H,.styles-module_ZoomOut__hPiqH{background-color:transparent}.styles-module_ZoomIn__2ir-Q .styles-module_ModalWrapper__2HHmh{animation-name:styles-module_zoomIn__1TQIL}.styles-module_ZoomOut__hPiqH .styles-module_ModalWrapper__2HHmh{animation-name:styles-module_zoomOut__1-Bgw}.styles-module_EnlargeOut__2dM_H .styles-module_ModalWrapper__2HHmh{animation-name:styles-module_enlargeOut__53Ho2}@keyframes styles-module_zoomIn__1TQIL{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes styles-module_enlargeOut__53Ho2{0%{opacity:1}to{opacity:0;transform:scale3d(1.3,1.3,1.3)}}@keyframes styles-module_zoomOut__1-Bgw{0%{opacity:1}to{opacity:0;transform:scale3d(.3,.3,.3)}}.styles-module_Title__99Pj_{padding:9px 20px;background-color:rgba(var(--white-rgb),.05);color:var(--brown-gray);font-size:15px;display:flex;justify-content:space-between;align-items:center}.styles-module_CloseIcon__3ArTC{cursor:pointer;fill:var(--brown-gray);width:22px;height:22px}.styles-module_CloseIconWrapper__2KCq8{margin-left:auto}.styles-module_TitleBackground__2oYCU{background-color:transparent!important}";
var styles = {"BackDrop":"styles-module_BackDrop__DslUV","ModalWrapper":"styles-module_ModalWrapper__2HHmh","ZoomOut":"styles-module_ZoomOut__hPiqH","EnlargeOut":"styles-module_EnlargeOut__2dM_H","ZoomIn":"styles-module_ZoomIn__2ir-Q","zoomIn":"styles-module_zoomIn__1TQIL","zoomOut":"styles-module_zoomOut__1-Bgw","enlargeOut":"styles-module_enlargeOut__53Ho2","Title":"styles-module_Title__99Pj_","CloseIcon":"styles-module_CloseIcon__3ArTC","CloseIconWrapper":"styles-module_CloseIconWrapper__2KCq8","TitleBackground":"styles-module_TitleBackground__2oYCU"};
styleInject(css_248z,{"insertAt":"top"});

var Modal = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, classNames = _a.classNames, width = _a.width, containerClassName = _a.containerClassName, exitAnimation = _a.exitAnimation, backDropClassName = _a.backDropClassName, onExited = _a.onExited, dataCy = _a.dataCy, props = __rest(_a, ["isOpen", "children", "classNames", "width", "containerClassName", "exitAnimation", "backDropClassName", "onExited", "dataCy"]);
    return ReactDOM.createPortal(React.createElement(CSSTransition, __assign({ in: isOpen, timeout: 250, classNames: __assign({ appear: styles.ZoomIn, enter: styles.ZoomIn, exit: styles[exitAnimation] }, classNames), onExited: onExited, mountOnEnter: true, unmountOnExit: true }, props),
        React.createElement("div", { className: merge(styles.BackDrop, backDropClassName) },
            React.createElement("div", { "data-cy": dataCy, style: { maxWidth: width }, className: merge(styles.ModalWrapper, containerClassName) }, children))), document.body);
};
Modal.defaultProps = {
    containerClassName: '',
    backDropClassName: '',
    exitAnimation: 'EnlargeOut',
    classNames: {},
    width: 400,
};
var ModalTitle = function (_a) {
    var transparentBackground = _a.transparentBackground, text = _a.text, onCancel = _a.onCancel;
    return (React.createElement("div", { className: merge(styles.Title, transparentBackground && styles.TitleBackground), "data-cy": "modal-title" },
        text,
        React.createElement("div", { className: styles.CloseIconWrapper, "data-cy": "modal-close-button", onClick: function (event) { return onCancel(event); } },
            React.createElement(Close, { className: styles.CloseIcon }))));
};

export { Modal, ModalTitle };
